// Offers routes
export default [
  {
    path: 'offers',
    name: 'offers',
    redirect: 'offers/index',
    component: () =>
      import(/* webpackChunkName: "offers" */ '../views/offers/Offers.vue'),
    children: [
      {
        path: 'index',
        name: 'offersManagement',
        meta: {
          tabbable: true,
          tableKeys: ['offers'],
          filterKeys: ['offers'],
          formKeys: [],
          routePermissions: [],
        },
        component: () =>
          import(
            /* webpackChunkName: "offersIndex" */ '../views/offers/OffersIndex.vue'
          ),
      },
    ],
  },
];
